import { Component, OnInit, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../../shared/authorization/authorization.service';
import { PAGE_CONSTANTS } from '../../../../shared/constants/page.constants';
import { STATIC_DATA, STATIC_JSON_DATA_PATH } from '../../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../../shared/services/shared-data-service';
import { PageConfig } from '../../../../shared/authorization/auth.config';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';
import { DatePipe } from '@angular/common';
import { ListService } from '../../../../shared/services/list.service';
import { BillingService } from '../../../../services/billing.service';
import { UserService } from '../../../../services/user.service';
import { LoggerService } from '../../../../shared/services/logger.service';
import { SectionsService } from '../../../../services/sections.service';

@Component({
  selector: 'ppl-payment-recon-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent],
  templateUrl: './payment-recon-list.component.html',
  styleUrl: './payment-recon-list.component.css',
})
export class PaymentReconListComponent implements OnInit {
  sharedDataKey: string = STATIC_DATA.SHARED_PAYMENT_RECON_DATA;
  pageId: string = PAGE_CONSTANTS.PAYMENT_RECON_GRID_PAGE;
  columnsToBeHidden: string[] = [];
  actionsToBeHidden: string[] = [];
  isPageRestrictionLoaded = false;
  programName!: string;
  lazyLoad = true;
  claims: any[] = [];
  appliedFilters: any;
  @ViewChild(ListTableComponent) childComponent!: ListTableComponent;

  fields = [
    { field: 'timeframe', show: true },
    { field: 'pplIcn', show: true },
    { field: 'paymentNumber', show: true },
  ];

  cols = [];
  
  constructor(
    private authService: AuthorizationService,
    private sharedDataService: SharedDataService,
    private authUtility: AuthorizationUtility,
    private listService: ListService,
    private billingService: BillingService,
    private userService: UserService,
    private logger : LoggerService, 
    private sectionService : SectionsService

  ) {}

  ngOnInit(): void {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.setPageAccess();
    const navigationState = window.history.state;
    this.getColumnData();
    if (navigationState.fileId) {
      const { fileId } = navigationState;
      const filters = [];
      console.log(fileId);
      filters.push({
        jsonPath: 'tasBillingReconFileMasterId',
        value: fileId,
        operator: 'Equal',
      });
      this.searchClaims(filters);
    } else {
      console.log('No state data available');
    }
  }

  async getColumnData() {
    try {
        const tempCols = await this.sectionService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.PAYMENT_RECON_LIST_PAGE_HEADERS,
          'billing'
        );
        this.cols = tempCols.columns;
    } catch (e) {
      this.logger.debug('Error in getting column data', e);
    }
  }

  rowClicked(rowDetail: any) {}

  onSearch(filters: any) {
    this.appliedFilters = filters;
    this.searchClaims(filters);
  }

  onPageLoad(event: any) {
    this.searchClaims(
      this.appliedFilters,
      event.startingPageNumber,
      event?.first ?? 0
    );
  }

  buildRequestPayload(
    pageName: string,
    orderBy: string,
    searchParams: [],
    startingPageNumber = 1
  ) {
    const payload: any = {
      pageName: pageName,
      programCode: this.programName,
      condition: 'and',
      recordsPerPage: 20,
      startingPageNumber: startingPageNumber,
      searchParam: searchParams,
      orderByColumn: orderBy ? [orderBy] : [],
      orderBy: ["desc"],
    };

    return payload;
  }

  searchClaims(filters: any, startingPageNumber = 1, currentPage = 0) {
    if (startingPageNumber == 1) {
      this.claims = [];
    }
    const processedPayload = this.buildRequestPayload(
      'billingPaymentFileDetailListView',
      'createddate',
      filters,
      startingPageNumber
    );

      this.listService
        .getListData(processedPayload, 'billing')
        .subscribe((data: any) => {
          const records = data.responsedata;
          records.forEach((element: any) => {
            element.claimStatusDescription = element.claimStatusCode + ' - ' + element.claimStatusDescription;
          });
          if (startingPageNumber > 1) {
            this.claims = [...this.claims, ...records];
            this.childComponent.resetPagination(
              startingPageNumber,
              currentPage
            );
          } else {
            this.claims = records;
          }
          this.claims = this.formatAmounts(this.claims);
        });
  }

  formatAmounts(claims: any){
    return claims.map((claim: any) => {
      return {
        ...claim,
        patientPaidAmount: claim.patientPaidAmount ? this.billingService.formatCurrency(claim.patientPaidAmount) : claim.patientPaidAmount,
        paymentAmount: claim.paymentAmount ? this.billingService.formatCurrency(claim.paymentAmount) : claim.paymentAmount
      };
    });
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService
        .fetchPageAuthorization(this.programName, this.pageId, 'LIST')
        .subscribe((response) => {
          this.setRestrictions(response);
        });
    } else {
      this.setRestrictions(pageConfig);
    }
  }

  
  private setRestrictions(pageConfig: PageConfig) {
    if (pageConfig) {
      this.columnsToBeHidden = this.authUtility.getHiddenColumns(
        pageConfig,
        this.pageId
      );
      this.actionsToBeHidden = this.authUtility.getHiddenActions(
        pageConfig,
        this.pageId
      );
    }
    this.isPageRestrictionLoaded = true;
  }

  clearData() {
    this.sharedDataService.clearData(this.sharedDataKey);
  }
}
